import React from "react";
import { Link, useParams } from "react-router-dom";
import Popup from "./Popup";
import Heading from "./Heading";
import Input from "./Input";
import "../sass/Login.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";

const GetNotified = () => {
  let params = useParams();
  const url = params.id.split("-");

  return (
    <Popup>
      <Heading type="H2">
        Get notified to your email whenever <strong>{url[1]}</strong> changes at{" "}
        <strong>{url[0]}</strong>.
      </Heading>
      <Input type="email" label="Please provide your email" />
      <div className="popupFooter">
        <span></span>
        <span>
          <Link className="btn btn-link" to="/">
            Cancel
          </Link>
          <button className="btn btn-primary">Get Notified</button>
        </span>
      </div>
    </Popup>
  );
};

export default GetNotified;
